import { ApplicationState } from '../../store/application-store';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap, filter, map, distinctUntilChanged, take } from 'rxjs';
import { select, Store } from '@ngrx/store';
import * as profileSelectors from '../selectors/profiles';
import { Profile } from '../models/profile';
import * as profileActions from '../actions/profiles';

@Injectable()
export class ProfileService {

  constructor(
    private readonly store: Store<ApplicationState>
    ) { }

    loadProfiles(product: string) {
      this.store.dispatch(new profileActions.LoadAll(product));
    }

  getAllProfiles(product: string): Observable<Profile[]> {
    return this.store
      .pipe(
      select(profileSelectors.selectAllProfiles()),
        tap((state: object) => {
          if (state['loading'] === false && (state['profiles'].length === 0 || state['product'] != product) && !state['error'])
            this.store.dispatch(new profileActions.LoadAll(product));
      }),
      map((state: object) => state['profiles']),
        distinctUntilChanged()
      );
    }

    getLoading(): Observable<boolean> {
      return this.store.select(profileSelectors.selectLoading());
    }

}
